import React from "react";
import { motion } from "framer-motion";

const stagger = {
  initial: {},
  animate: { transition: { staggerChildren: 0.12 } },
};

const fadeUp = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } },
};

export default function Contact() {
  return (
    <motion.section
      className="max-w-[800px] mx-auto px-6 sm:px-8 py-20 sm:py-28"
      variants={stagger}
      initial="initial"
      animate="animate"
    >
      <motion.figure variants={fadeUp} className="relative w-full overflow-hidden mb-14">
        <img
          src="/photos/rooftop-show.jpeg"
          alt=""
          className="w-full h-auto block"
          style={{ aspectRatio: "3 / 2" }}
        />
      </motion.figure>

      <motion.p variants={fadeUp} className="font-sans text-[14px] leading-[1.8] text-[var(--body)] mb-8">
        For collaborations, questions, or just to say hello.
      </motion.p>

      <motion.div variants={fadeUp}>
        <a
          href="mailto:muratgulcelik@gmail.com"
          className="font-sans text-[16px] text-[var(--text)] hover:text-[var(--muted)] transition-colors"
        >
          muratgulcelik@gmail.com
        </a>
      </motion.div>

      <motion.div variants={fadeUp} className="mt-4">
        <span className="font-sans text-[13px] text-[var(--muted)]">
          New York · Istanbul
        </span>
      </motion.div>
    </motion.section>
  );
}
